var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-alert',_vm._b({attrs:{"show-icon":_vm.hasIcon,"effect":_vm.alertTheme},on:{"close":function($event){return _vm.$emit('close')}}},'el-alert',_vm.trimAttrs(_vm.$attrs),false),[_c('template',{slot:"title"},[_vm._t("title")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }